<template>
  <div
    v-observe-visibility="{
      callback: viewHandler,
      once: true
    }"
    v-lazy:background-image="getThumbnailPath(banner.urlDesktop, banner.urlMobile)"
  >
    <router-link :to="localizedRoute('/' + banner.link)" rel="noreferrer" class="p40 w-100">
      <h2
        class="title h4 weight-500 m0"
        :style="{ color: '#' + banner.text1color }"
        v-html="banner.text1"
      />
      <p
        class="subtitle h4 weight-500"
        :style="{ color: '#' + banner.text2color }"
        v-if="banner.text2"
        v-html="banner.text2"
      />
      <button-outline class="button">
        {{ $t('Check') }}
      </button-outline>
    </router-link>
  </div>
</template>

<script>
import ButtonOutline from 'theme/components/theme/ButtonOutline'
import { getThumbnailPath as _thumbnailHelper } from '@vue-storefront/core/helpers'

export default {
  name: 'BannerTile',
  components: {
    ButtonOutline
  },
  props: {
    banner: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    viewHandler (isVisible) {
      if (isVisible) {
        this.$store.commit('ui/VIEW_BANNER', this.banner)
      }
    },
    getThumbnailPath (urlDesktop, urlMobile) {
      if (!this.$device.isMobile) {
        return _thumbnailHelper(urlDesktop, 1024, 635, 'banners')
      } else {
        return _thumbnailHelper(urlMobile, 767, 445, 'banners')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$dark-border: color(secondary);
$white: color(white);
$black: color(black);
$main: color(main);

.button {
  border-color: #FFFFFF;
  color: #FFFFFF;
  min-width: auto;
  padding: 5px 20px;
  border-width: 2px;
  font-size: 14px;
  margin-top: 50px;
  outline: 0;
  &:hover,
  &:focus {
    color: $main;
    background: $white;
    border-color: $white;
  }
  @media (max-width: 767px) {
    font-size: 26px;
    border: none;
    margin-left: auto;
    background: #FF4600;
  }
}
</style>
